import { apicall } from "../../services/api";
import { GET_DASHBOARD, ERR_DASHBOARD} from "./actionTypes";

export const getDashboard = () => async (dispatch) => {
	try {
		const res = await apicall(`dashboard`, "get");
		
			dispatch({
				type: GET_DASHBOARD,
				//payload: res.data.data,
				payload: res.data,
			});
            
		
	} catch (err) {
		dispatch({
			type: ERR_DASHBOARD,
			payload: { msg: err.response.msg, status: err.response.status },
		});
	}
};
